var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearnerflagg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 63,
    viewBox: "0 0 50 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8476 18.5805C49.6571 18.9264 49.6571 20.0737 48.8476 20.4196L14.8929 34.9264C14.2331 35.2082 13.5 34.7243 13.5 34.0069V4.99326C13.5 4.27583 14.2331 3.79181 14.8929 4.07367L48.8476 18.5805Z",
    fill: "#EF5451"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.4026C8 1.62796 8.89543 1 10 1H13C14.1046 1 15 1.62796 15 2.4026V55H8V2.4026Z",
    fill: "#FFCB29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1H13C14.1046 1 15 1.62796 15 2.4026V55H12V1Z",
    fill: "#FCB316"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 59C1 56.7909 2.79086 55 5 55H18C20.2091 55 22 56.7909 22 59V61H1V59Z",
    fill: "#3D82C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnerflagg);
export default __webpack_public_path__ + "static/media/learner flagg.7a8bebaa.svg";
export { ForwardRef as ReactComponent };